// extracted by mini-css-extract-plugin
export default {"memberWalletContainer":"BBeEp","memberWalletButton":"uSiRa"};